/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Content\Home\HomeButton\HomeButton.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday September 3rd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 3rd 2024 9:47:50 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Button } from "@mui/material";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import { Link } from "react-router-dom";
import Styles from "Content/Home/HomeButton/HomeButton.module.css";

type HomeButtonProps = {
    img: string,
    tabName: string,
    text: string,
};

export default function HomeButton(props: HomeButtonProps) {
    const urlToNavigate = (name: string) => {
        return `${RouterPathResolver.routeCars.path}?page=1&tabkey=${name}`;
    };

    return (
        <Link to={urlToNavigate(props.tabName)} className={`${Styles.link}`}>
            <div className={`${Styles.box}`}>
                <img className={`${Styles.imgW}`} src={props.img} alt='' />
                <Button variant="contained">{props.text}</Button>
            </div>
        </Link>
    );
};
